import styled from '@emotion/styled';
import { ChevronRightIcon, Css, H5, Responsive } from '../../../ui';
import { Color } from '../../../styles/Color';
import { Shadow } from '../../../styles/Shadow';
import { RouterLink } from '../../../components/common/link/RouterLink';
import { ParkingAvailabilityStatus } from '../domain/models/ParkingAvailabilityStatus';
import { getStatusColor } from '../use-cases/getStatusColor';

export const ParkingLotsContainer = styled.div`
	max-width: ${Css.pxToRem(575)};
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: none;
	}
`;

export const TableName = styled(H5)`
	margin-bottom: 0;
`;

export const Table = styled.div`
	background-color: ${Color.PrimaryWhite};
	border-radius: 8px;
	box-shadow: ${Shadow.Desktop};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		box-shadow: ${Shadow.Mobile};
	}
`;

export const HeaderRow = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	padding-bottom: ${Css.pxToRem(16)};
	column-gap: ${Css.pxToRem(24)};
	padding-right: ${Css.pxToRem(16)};

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		column-gap: ${Css.pxToRem(12)};
	}
	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		column-gap: ${Css.pxToRem(24)};
	}
`;

export const TableRowWrapper = styled.div`
	&:not(:last-child) {
		border-bottom: 1px solid ${Color.BodyBackground};
	}
`;

export const TableRow = styled(HeaderRow)`
	min-height: ${Css.pxToRem(64)};
	align-items: center;
	padding-bottom: 0;
	padding-left: ${Css.pxToRem(24)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		min-height: ${Css.pxToRem(76)};
		column-gap: ${Css.pxToRem(12)};
	}
`;

export const RowCell = styled.div<{ hideOnMobile?: boolean }>`
	min-width: ${Css.pxToRem(50)};
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		${({ hideOnMobile }) => hideOnMobile && `display: none;`}
	}
`;

export const RowTitleCell = styled(RowCell)`
	min-width: ${Css.pxToRem(130)};
`;

export const RowIconCell = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		justify-content: center;
	}
	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		display: none;
	}
`;

export const StatusText = styled.span<{ status: ParkingAvailabilityStatus }>`
	color: ${({ status }) => getStatusColor(status)};
	font-weight: 700;
`;

export const ShowOnMobile = styled.div`
	display: none;
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: block;
	}
`;

export const ShowEvStatusOnMobile = styled(ShowOnMobile)`
	color: ${Color.Success};
`;

export const RowEvCell = styled(RowCell)`
	min-width: ${Css.pxToRem(100)};
	display: flex;
	justify-content: center;
`;

export const RowDetailsPageLinkCell = styled(RowCell)`
	min-width: ${Css.pxToRem(24)};
	margin-left: ${Css.pxToRem(-24)};
	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		margin-left: ${Css.pxToRem(-12)};
	}
	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-left: ${Css.pxToRem(-24)};
	}
`;

export const StyledChevron = styled(ChevronRightIcon)`
	color: ${Color.Neutral};
`;

export const NoEvChargingDash = styled.div`
	width: ${Css.pxToRem(24)};
	height: ${Css.pxToRem(3)};
	border-radius: ${Css.pxToRem(3)};
	background-color: ${Color.Neutral};
`;

export const RowRateCell = styled(RowCell)`
	font-weight: 700;
	display: flex;
	flex-direction: column;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		align-items: flex-end;
		min-width: ${Css.pxToRem(91)};
	}
`;

export const StyledRouterLink = styled(RouterLink)`
	text-decoration: none;
	color: ${Color.OnBackgroundText};
	font-weight: 400;

	&:active {
		color: ${Color.OnBackgroundText};
	}
`;
